import PageTitle from '../../../components/shared/PageTitle';
import S01 from './S01';
import S02 from './S02';

const Pulmuone = () => {
  return (
    <div>
      <PageTitle title="풀무원샘물" />
      <S01 />
      <S02 />
    </div>
  );
};

export default Pulmuone;
